<template>
  <div class="footer">
        	<div class="footer-wrap wrap-sm float-wrap">
        		<div class="footer-top">
        			<img  class="footer-logo" src="@/assets/images/common/logo.png">
        			<div class="footer-links">
        				<p>FOLLOW US</p>
        				<a href="https://www.instagram.com/ksasurf" target="_blank"><img src="@/assets/images/icon/icon-ig.png" alt="Instagram"></a>
        				<a href="https://www.facebook.com/KoreaSurfingAssociation/?locale=ko_KR" target="_blank"><img src="@/assets/images/icon/icon-fb.png" alt="Facebook"></a>
        				<a href="https://www.youtube.com/@koreasurfingassociation4755" target="_blank"><img src="@/assets/images/icon/icon-youtube.png" alt="Youtube"></a>
        			</div>
        		</div>
        		<div class="footer-info">
        			<span>상호: 대한서핑협회</span><br/>
        			<span>대표자: </span> 서종희<br/>
        			<span>고유등록번호: </span> 271-82-00078<br/>
        			<span>주소: </span> 부산광역시 해운대구 해운대해변로203 오션타워 1828호<br/>
        			<span>이메일: </span> <a href="mailto:info@koreasurfing.org">info@koreasurfing.org</a><br/>
        			<span>전화: </span> +82-51-740-5425
        		</div>
        	</div>
        	<p class="footer-copy"><em>Copyright ⓒ Korea Surfing Association All right reserved.</em></p>
        </div>
</template>

<script>
export default {

}
</script>

<style>
.footer-wrap {
  display: block;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  margin-top: 0;
  padding-top: 10px;
}

.footer-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  text-align: center;
}

.footer-logo {
  width: 80px;
  height: auto;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 0;
  justify-content: center;
}

.footer-links p {
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.footer-links a {
  display: inline-block;
  margin: 0;
  padding: 0;
}

.footer-links img {
  width: 20px;
  height: 20px;
}

.footer-info {
  display: block;
  margin: 0 auto;
  padding: 0;
  font-size: 15px;
  color: #333;
  text-align: center;
  line-height: 1.8;
  clear: both;
  width: 100%;
}

.footer-info span {
  color: #666;
  font-weight: 500;
}

.footer-info a {
  color: #333;
  text-decoration: none;
  white-space: nowrap;
}

.footer-info a:hover {
  text-decoration: underline;
}
</style>